import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";

import NavBar from "../components/NavBar";
import FrTextInput from '../components/FrTextInput';
import UserOptions from "../components/UserOptions";
import FrLoading from "../components/FrLoading";

import api from '../services/api';
import { conferePermissao, paramsToObject } from "../utils/functions";

import './styles/DefaultReg.css';
import FooterDelphus from "../components/FooterDelphus";

const swal = withReactContent(Swal);

const RegEstado = () => {

    const [data, setData] = useState({});
    const [updateType, setUpdateType] = useState(false);
    const [enableEdit, setEnableEdit] = useState('N');

    useEffect(() => {
        const fetchData = async () => {
            let tela = 'Estados'
            let consulta = await api.getAcessos(tela, 'Consulta')
            if (consulta !== 'S') {
                swal.fire('Usuário sem acesso', 'Usuário sem acesso a essa tela!', 'warning')
                    .then((result) => {
                        if (result.value) {
                            window.history.back()
                        }
                    })
            } else {
                swal.fire({
                    html: <FrLoading text="Carregando..." />,
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                });

                const urlParams = new URLSearchParams(window.location.search);
                let query = paramsToObject(urlParams);

                if (query.codigo > 0) {
                    setEnableEdit(await api.getAcessos('Estados', 'Alteracao'));
                } else {
                    setEnableEdit(await api.getAcessos('Estados', 'Inclusao'));
                }

                if (query.codigo > 0) {
                    setUpdateType(true);
                    api.get('/estados?pk_est=' + query.codigo).then(r => {
                        if (r.data[0]) {
                            console.log(r.data[0]);
                            setData(r.data[0]);
                            swal.close();
                        } else {
                            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning').then((result) => {
                                window.history.back();
                            });
                        }
                    });
                } else swal.close();
            }
        }
        fetchData();
    }, []);

    const consistData = (data) => {
        let required = [
            'nome',
            'uf'
        ];

        let errors = [];

        required.forEach((curr, index) => {
            let fieldName = curr;
            if (!data[curr]) return errors.push(fieldName);
        });

        return errors;
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        swal.fire({
            title: 'ATENÇÃO',
            text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                const auxValues = { ...data };
                let errors = consistData(auxValues);
                console.log(errors.length);
                if (errors.length === 0) {
                    if (updateType) {
                        api.post('/estados/edit', auxValues).then(r => {
                            if (r.status === 200) {
                                swal.fire({
                                    title: 'Registro Alteraddo',
                                    text: "O registro foi alterado com sucesso!",
                                    icon: 'success',
                                }).then((result) => {
                                    if (result.value) {
                                        window.history.back();
                                    }
                                });
                            } else {
                                swal.fire({
                                    title: 'Erro!',
                                    text: "O registro não foi alterado!",
                                    icon: 'warning',
                                })
                            }
                        });
                    } else {
                        api.post('/estados/add', auxValues).then(r => {
                            if (r.status === 200) {
                                swal.fire({
                                    title: 'Registro Adicionado',
                                    text: "O registro foi adicionado com sucesso!",
                                    icon: 'success',
                                }).then((result) => {
                                    if (result.value) {
                                        window.history.back()
                                    }
                                });
                            } else {
                                swal.fire({
                                    title: 'Erro!',
                                    text: "O registro não foi adicionado!",
                                    icon: 'warning',
                                });
                            }
                        });
                    }
                } else {
                    swal.fire({
                        title: 'Erro!',
                        text: "Verifique o(s) campo(s) " + errors.join(','),
                        icon: "warning"
                    });
                }
            }
        });
    }

    const handleCancel = (e) => {
        e.preventDefault();
        swal.fire({
            title: 'ATENÇÃO',
            text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                window.history.back();
            }
        });
    }

    const handleChange = (e) => {
        const auxValues = { ...data };
        switch (e.target.name) {
            case 'CNPJ':
            default: auxValues[e.target.name] = e.target.value;
        }

        setData(auxValues);
    }

    return (
        <div className="defaultReg">
            <NavBar />
            <div className="defaultRegContent">
                <div className="defaultHeader">
                    <h3>{updateType ? 'Edição' : 'Inclusão'} de Estado</h3>
                    <UserOptions />
                </div>
                <br />
                <form id="regForm" onSubmit={handleSubmit}>

                    <FrTextInput
                        maxLength='50'
                        value={data.nome || ''}
                        onChange={handleChange}
                        name='nome'
                        id='nome'
                        color="#49573B"
                        label='Nome do Estado'
                        variant="outlined"
                        size="small"
                        required
                        style={{ width: 330 }}
                    />

                    <FrTextInput
                        maxLength='2'
                        value={data.uf || ''}
                        onChange={handleChange}
                        name='uf'
                        id='uf'
                        color="#49573B"
                        label="UF"
                        variant="outlined"
                        size="small"
                        required
                        style={{ width: 80 }}
                    />
                </form>
                <div className="regButtonsDiv">
                    {/* {enableEdit === 'S' ?
                        (<button onClick={handleSubmit}>Salvar</button>) : (<></>)} */}
                    <button onClick={handleSubmit}>Salvar</button>
                    <button onClick={handleCancel}>{enableEdit === 'S' ? 'Cancelar' : 'Fechar'}</button>
                </div>
                <FooterDelphus />
            </div>
        </div>
    );
}

export default RegEstado;